// extracted by mini-css-extract-plugin
module.exports = {"imageHolder":"Hemp_imageHolder__1V0KK","textContainer":"Hemp_textContainer__1CHPX","arrow":"Hemp_arrow__3kib4","rightImage":"Hemp_rightImage__1gTUx"};